import React from 'react';
import { TeamDisplay, TeamDisplayCheckbox, TeamDisplayLink } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { listType } from '../teamsList';
import { teamDisplayModulePropTypes } from './propTypes';

export const UTAH_2425_TEAM_ID = 59;
export const UTAH_TEAM_ID = 68;
const FOUR_NATION_TEAM_IDS = [60, 62, 66, 67];

const TeamDisplayModule = ({ team, season, teamDisplayProps, ...props }) => {

    const fixedTeam = { ...team };

    // Don't display 'Utah Hockey Club' for Utah Hockey Club
    if (fixedTeam.id === UTAH_2425_TEAM_ID) {
        fixedTeam.commonName = 'Hockey Club';
    }

    // Hide 'Team' for 4 Nations teams
    if (FOUR_NATION_TEAM_IDS.includes(fixedTeam.id)) {
        fixedTeam.placeName = '';
    }

    switch (props.listType) {
        case listType.FILTER_LIST:
            return (
                <TeamDisplayCheckbox
                    team={ fixedTeam }
                    season={ season }
                    { ...teamDisplayProps }
                />
            );
        break;
        case listType.LINK_LIST:
            return (
                <TeamDisplayLink
                    team={ fixedTeam }
                    season={ season }
                    path={`/teams/${team.slug}`}
                    { ...teamDisplayProps }
                />
            );
        break;
        default:
            return (
                <TeamDisplay
                    team={ fixedTeam }
                    season={ season }
                    { ...teamDisplayProps }
                />
            );
    }
};

TeamDisplayModule.propTypes = teamDisplayModulePropTypes;

export default TeamDisplayModule;